import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="partner-tasks--equipment-collected"
export default class extends Controller {
  static targets = ['collectedLabel', 'isNotCollectedLabel', 'switchValue']

  connect() {
    this.setValue()
  }

  switch() {
    this.setValue()
  }

  setValue() {
    if (this.switchValueTarget.checked) {
      this.collectedLabelTarget.classList.remove('d-none')
      this.collectedLabelTarget.classList.add('d-block')

      this.isNotCollectedLabelTarget.classList.add('d-none')
    } else {
      this.collectedLabelTarget.classList.remove('d-block')
      this.collectedLabelTarget.classList.add('d-none')

      this.isNotCollectedLabelTarget.classList.remove('d-none')

    }
  }

}
